import './LoaderComponent.scss';

import React from 'react';

const LoaderComponent = () => {
  return <div className="LoaderComponent"></div>;
};

export default LoaderComponent;
